module.exports = __webpack_public_path__ + "static/media/29ADMSPC4.bfe7b019.jpg";